module.exports = __webpack_public_path__ + "static/media/message.e82f95bb.svg";